import CustomerOverviewPage from './customer-overview-page'

export default CustomerOverviewPage